import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import GrainOverlay from "../components/GrainOverlay";

const SHARE_URL = "https://gonesoon.in/";
const SHARE_TEXT =
  "GoneSoon — a private local savings club. Exclusive prices from selected places around the city. Limited drops. Once gone, they're gone. Join the private waitlist:";

export default function Success() {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    document.title = "You're on the list | GoneSoon";
    window.scrollTo(0, 0);
  }, []);

  const handleShare = async () => {
    const shareData = {
      title: "GoneSoon — Your private local savings club",
      text: SHARE_TEXT,
      url: SHARE_URL,
    };
    try {
      if (navigator.share) {
        await navigator.share(shareData);
        return;
      }
    } catch (err) {
      // user cancelled or share not available — fall through to copy
    }
    try {
      await navigator.clipboard.writeText(`${SHARE_TEXT} ${SHARE_URL}`);
      setCopied(true);
      toast.success("Invite link copied");
      setTimeout(() => setCopied(false), 2500);
    } catch (err) {
      toast.error("Could not copy the link");
    }
  };

  return (
    <div data-testid="success-page" className="relative">
      <GrainOverlay />
      <div className="bg-coral">
        <Nav variant="coral" />
      </div>

      <section className="bg-coral text-white min-h-[80vh] flex items-center">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-24 md:py-32 w-full">
          <div className="pill text-white border-white/60 mb-10" data-testid="success-pill">
            <span className="pill-dot" />
            You&rsquo;re in the queue
          </div>
          <h1
            data-testid="success-headline"
            className="h-display text-white text-[3rem] md:text-[8rem] leading-[0.92] max-w-[14ch]"
          >
            You&rsquo;re on the private list.
          </h1>

          <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-10">
            <div className="md:col-span-6 space-y-6 text-white/90 text-lg leading-relaxed max-w-lg">
              <p>We&rsquo;ll let you know when your GoneSoon access is ready.</p>
              <p className="text-white/75">
                Keep an eye on your inbox and WhatsApp. Early invitations and selected drops may only stay available for a limited time.
              </p>
            </div>
            <div className="md:col-span-6 md:justify-self-end flex flex-col gap-4 md:items-end">
              <a
                href="https://www.instagram.com/gonesoonapp"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="success-follow"
                className="btn-primary btn-on-coral"
              >
                Follow GoneSoon on Instagram
                <span aria-hidden="true">→</span>
              </a>
              <Link
                to="/"
                data-testid="success-home"
                className="text-sm uppercase tracking-[0.22em] text-white/80 hover:text-white ed-link"
              >
                Back to home
              </Link>
            </div>
          </div>

          <div className="mt-24 pt-8 border-t border-white/20 max-w-2xl">
            <p className="text-xs uppercase tracking-[0.22em] text-white/70 mb-3">
              Share
            </p>
            <p className="h-display text-2xl md:text-3xl text-white leading-tight">
              Know someone who always finds the best deals first?
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-3">
              <button
                type="button"
                onClick={handleShare}
                data-testid="success-share-button"
                className="btn-primary btn-on-coral"
              >
                {copied ? "Link copied" : "Share GoneSoon"}
                <span aria-hidden="true">→</span>
              </button>

              <a
                href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
                  `${SHARE_TEXT} ${SHARE_URL}`
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="success-share-whatsapp"
                className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] font-bold border border-white/60 rounded-full px-5 py-3 text-white hover:bg-white hover:text-coral transition-colors"
              >
                WhatsApp
              </a>

              <a
                href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
                  SHARE_TEXT
                )}&url=${encodeURIComponent(SHARE_URL)}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="success-share-twitter"
                className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] font-bold border border-white/60 rounded-full px-5 py-3 text-white hover:bg-white hover:text-coral transition-colors"
              >
                X / Twitter
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
